import * as React from 'react';
import PropTypes from 'prop-types';
import {Button, Header, Icon, Label, Modal} from "semantic-ui-react";
import {translate} from "react-i18next";
import {connect} from "react-redux";
import { COLOR_CONTRAST,  COLOR_SECONDARY} from "../misc/vars";
import {dismissError} from "../actions/errorActions";

const ErrorView = ({t, error, onDismiss, count}) => (
	<Modal open={!!error} basic size="small" style={{borderRadius: 8, background: COLOR_SECONDARY }}>
		<Header>
			<Icon name="warning sign" fitted={true} color="red" size="large"/>
			{/*<Header.Content><span style={{fontWeight: 'bold', color: COLOR_CONTRAST}}>{t('errors.title')}</span></Header.Content>*/}
			{count > 1 && <Label color="red" ribbon="right" content={'+ '+(count-1)}/>}
		</Header>
		<Modal.Content>
			<p style={{color: COLOR_CONTRAST}}>{t([error || 'errors.default', 'errors.default'])}</p>
		</Modal.Content>
		<Modal.Actions>
			<Button color="red" inverted={true} onClick={onDismiss}><Icon name="remove"/> {t('actions.dismiss')}</Button>
		</Modal.Actions>
	</Modal>
);

ErrorView.propTypes = {
	error: PropTypes.string,
	onDismiss: PropTypes.func.isRequired,
	count: PropTypes.number
};
ErrorView.defaultProps = {
	error: null,
	onDismiss: () => console.info('Should dismiss error...'),
	count: 0
};

const m2s = state => ({
	error: state.error.length ? state.error[state.error.length - 1] : null,
	count: state.error.length
});
const m2d = dispatch => ({
	onDismiss: () => dispatch(dismissError())
});

export default connect(m2s, m2d)(translate()(ErrorView));


// WEBPACK FOOTER //
// ./src/containers/ErrorController.js